/**
 * 👎 reasons for an AI reply — same list as the server (chat_feedback_service.REASONS); the
 * label is what gets saved. Task: githubDOCS/TASKS/2026-10-27_AI相談の回答に評価ボタン.md
 */
export const CHAT_FEEDBACK_REASONS = ['数字が違う', '質問に答えていない', '役に立たない', '言い方が気になる', 'その他'];

/** ひと言（任意）max length — same as the server (chat_feedback_service.MAX_COMMENT). */
export const CHAT_FEEDBACK_COMMENT_MAX = 200;
